import { Price } from "src/components/Price";

export function MaterialSwapPrice(props: { valueInCents: number }) {
  const { valueInCents } = props;
  const displayDirection = valueInCents > 0;
  return <Price valueInCents={valueInCents} displayDirection={displayDirection} invertColors zeroIs="neutral" />;
}
